var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 70,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35,
    r: 32.5,
    fill: "#fff",
    stroke: "#a2bc3a",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d490f",
    d: "M35.5 17c-9.93 0-18 8.07-18 18s8.07 18 18 18 18-8.07 18-18-8.07-18-18-18Zm0 2.4c8.63 0 15.6 6.97 15.6 15.6 0 8.63-6.97 15.6-15.6 15.6-8.63 0-15.6-6.97-15.6-15.6 0-8.63 6.97-15.6 15.6-15.6Zm0 5.6c-3.3 0-6 2.7-6 6 0 .63.57 1.23 1.2 1.23s1.2-.6 1.2-1.23c0-2 1.6-3.6 3.6-3.6s3.6 1.6 3.6 3.6c.01 1.64-.83 2.48-2.01 3.6-.6.56-1.25 1.14-1.8 1.9a4.93 4.93 0 0 0-.99 2.9c0 .63.57 1.23 1.2 1.23s1.2-.6 1.2-1.23c0-.6.17-1 .52-1.49.36-.48.9-1 1.52-1.57 1.22-1.16 2.77-2.4 2.76-5.34 0-3.28-2.7-6-6-6Zm0 16.8a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2Z"
  })));
};
export default SvgQuestionMark;